import { render } from "./PostPickerConfig.vue?vue&type=template&id=810128fc&ts=true"
import script from "./PostPickerConfig.vue?vue&type=script&lang=ts"
export * from "./PostPickerConfig.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__